import { UtcDate } from '@/helpers/date';

export default {
  computesRequired: true,
  validate: (value) => {
    let valid = true;
    const todayUtc = new UtcDate();
    const birthDate = new UtcDate(value);

    const isAgeInFuture = birthDate.isAfter(todayUtc);
    if (isAgeInFuture) valid = false;
    return {
      valid,
      required: true,
    };
  },
  message: (fieldName, { _value_: v }) => {
    const todayUtc = new UtcDate();
    const birthDate = new UtcDate(v);

    const isAgeInFuture = birthDate.isAfter(todayUtc);
    if (isAgeInFuture) return 'Your pet cannot be born in the future.';
  },
};
